<script setup lang="ts">
import {ref, watch} from "vue";
import {trackEvent} from "@/services/event.service";

const model = defineModel()
const props = defineProps({
  title: String,
  event_id:  String,
  event_label:String,
  placeholder: {
    type: String,
    default: "Select filter"
  },
  options: {
    type: Array
  }
})

const selections = ref(model.value)
const update = () => {
  model.value = selections.value;

  const selectedLabels = props.options
      .filter(option => selections.value.includes(option.id))
      .map(option => option.name);

  trackEvent(`cosmosy.ga.filters.${props.event_id}`, {
    event_label: props.event_label,
    selected_ids: selections.value.join(','),
    selected_labels: selectedLabels.join(', '),
    selected_count: selections.value.length,
  });
};


watch(model, (value)=>{
  selections.value = value
})

</script>
<template>
    <span class="font-bold responsive-title-6">{{ props.title }}</span>
    <div>
      <div class="flex flex-row mt-2  items-center justify-space-between"
           v-for="val in props.options"
           :key="val.name">
        <label for="sailor" class="font-bold">{{ val.name }}</label>
        <v-checkbox-btn density="compact" class="!flex-none"
                      multiple
                      v-model="selections"
                      @update:modelValue="update"
                      :value="val.id"/>
      </div>
    </div>
</template>


<style scoped>
/*Checkbox styling*/
:deep(.v-selection-control) {
  width: 24px !important;
  height: 24px !important;
  border: 1px solid #8C8B94 !important; /* Dark grey border */
  border-radius: 6px !important; /* Rounded corners */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white !important; /* Default background */

}

/* Center the icon (unchecked state) */
:deep(.v-selection-control__input i) {
  display: none;
}


/* Styling for checked state */
:deep(.v-selection-control--dirty .v-selection-control__input i) {
  color: black !important;
  background-color: white !important;
  border: 4px solid black !important;
  border-radius: 6px!important;
  width: 24px !important;
  height: 24px !important;
  display: flex;
  align-items: center;
  justify-content: center;

}

/* Remove default margins */
:deep(.v-selection-control__wrapper) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0px !important;
}

</style>